import { registerSW } from "virtual:pwa-register";
import { toast } from "react-toastify";

/**
 * Handles automatic PWA service worker updates with user feedback.
 */
export const enablePwaAutoUpdater = () => {
  // Add error handling for SW registration
  try {
    const updateSW = registerSW({
      immediate: true,

      onNeedRefresh() {
        // toast.info("🔄 New update available! Refreshing...", {
        //   autoClose: 2000,
        //   hideProgressBar: false,
        // });
        updateSW(true);
      },

      onOfflineReady() {
        // toast.success("✅ App is ready to work offline!", {
        //   autoClose: 2500,
        //   hideProgressBar: false,
        // });
      },

      // Add error handler
      onRegisterError(error: unknown) {
        console.error("SW registration error:", error);
      },
    });
  } catch (error) {
    console.error("Failed to register service worker:", error);
  }
};
